import axios from '@axios'

const route = 'ical/categoria'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getFeeds(context, categoryId) {
      return axios.get(`${route}/${categoryId}/feeds`)
    },
    storeFeeds(context, { categoryId, payload }) {
      return axios.post(`${route}/${categoryId}/feeds`, payload)
    },
    updateFeed(context, { categoryId, feedId, payload }) {
      return axios.patch(`${route}/${categoryId}/feeds/${feedId}`, payload)
    },
    deleteFeed(context, { categoryId, feedId }) {
      return axios.delete(`${route}/${categoryId}/feeds/${feedId}`)
    },
    syncFeed(context, { categoryId, feedId }) {
      return axios.post(`${route}/${categoryId}/feeds/${feedId}/sync`)
    },
    regenerateToken(context, categoryId) {
      return axios.post(`${route}/${categoryId}/regenerate-token`)
    },
  },
}
